(function () {
  'use strict';

  var API_BASE = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net';
  var DELIVERY_INTENT_KEY = 'florame_delivery_intent_v1';
  var DELIVERY_SCHEDULER_KEY = 'florame_ds_state_v18';
  var CONFIG = Object.assign({
    directoryEndpoint: API_BASE + '/portalPublicPartnerDirectoryV1',
    addressAutocompleteEndpoint: API_BASE + '/addressAutocomplete',
    addressResolveEndpoint: API_BASE + '/addressResolve'
  }, window.__floramePartnerDirectoryConfig || {});

  function readStoredDeliveryIntent() {
    try {
      var own = JSON.parse(sessionStorage.getItem(DELIVERY_INTENT_KEY) || '{}') || {};
      var scheduler = JSON.parse(sessionStorage.getItem(DELIVERY_SCHEDULER_KEY) || '{}') || {};
      var selectedDate = String(own.selectedDate || scheduler.selectedDate || '').slice(0, 10);
      var selectedTimeSlot = String(own.selectedTimeSlot || scheduler.selectedTimeSlot || '').trim().slice(0, 48);
      return {
        selectedDate: /^\d{4}-\d{2}-\d{2}$/.test(selectedDate) ? selectedDate : '',
        selectedTimeSlot: selectedTimeSlot
      };
    } catch (_) {
      return { selectedDate: '', selectedTimeSlot: '' };
    }
  }

  var TEXT = {
    it: {
      kicker: 'Partner Florame',
      title: 'Esplora i fioristi partner',
      subtitle: 'Trova gli atelier che possono preparare o consegnare il bouquet nella tua zona.',
      placeholder: 'Città, CAP o indirizzo di consegna',
      search: 'Cerca',
      near: 'Vicino a me',
      loading: 'Caricamento partner...',
      searching: 'Ricerca partner in corso...',
      all: 'Partner attivi',
      coverage: 'Partner che coprono questo indirizzo',
      city: 'Partner in zona',
      empty: 'Nessun partner trovato per questa ricerca.',
      emptyHint: 'Puoi comunque creare un bouquet e Florame cercherà la migliore copertura disponibile.',
      create: 'Crea bouquet',
      open: 'Apri storefront',
      covers: 'Copre indirizzo',
      pickup: 'Ritiro in negozio',
      delivery: 'Consegna',
      compactKicker: 'Il tuo fiorista',
      compactTitle: 'Un fiorista vicino a te',
      compactSubtitle: 'Scelto in base al tuo indirizzo e alla disponibilità reale.',
      viewAll: 'Vedi altri fioristi',
      collapse: 'Mostra meno',
      stockLive: 'Stock aggiornato',
      stockCoverageLive: 'Consegna disponibile qui',
      stockExpiring: 'Disponibilità da riconfermare',
      stockEmpty: 'Nessun bouquet disponibile ora',
      stockOffline: 'Temporaneamente non disponibile',
      stockUnknown: 'Disponibilità da verificare',
      newOnFlorame: 'Nuovo su Florame',
      verifiedOrder: 'ordine verificato',
      verifiedOrders: 'ordini verificati',
      addressError: 'Non riesco a leggere questo indirizzo. Prova con città o CAP.',
      gpsError: 'Posizione non disponibile. Inserisci un indirizzo o una città.',
      disabled: 'Directory partner non attiva.',
      results: 'risultati',
      oneResult: 'risultato',
      roma: 'Roma',
      coverageFallback: 'Copertura verificata su CAP'
      ,
      compareTitle: 'Fioristi che consegnano qui',
      compareTitleNoAddress: 'Confronta i fioristi',
      compareSubtitle: 'Confronta chi può preparare e consegnare il bouquet al destinatario.',
      compareChoiceKicker: 'Scelta del fiorista',
      compareChoiceTitle: 'Vuoi cambiare fiorista?',
      compareChoiceSubtitle: 'Confronta liberamente i partner prima di scegliere con chi continuare.',
      compareCoverageKicker: 'Consegna non coperta',
      compareCoverageTitle: 'Questo fiorista non consegna qui',
      compareCoverageSubtitle: 'Ti mostriamo soltanto i fioristi che possono raggiungere il destinatario.',
      compareProductKicker: 'Bouquet da ritrovare',
      compareProductTitle: 'Troviamone uno davvero acquistabile',
      compareProductSubtitle: 'Questa vecchia versione non è più in vendita. Cerchiamo chi può prepararne una compatibile, senza mandarti su una pagina inesistente.',
      compareProductEmpty: 'Non c’è una copia identica pronta, ma puoi ricreare questo stile.',
      compareCreateSimilar: 'Crea una variante simile',
      compareOnly: 'È l’unico fiorista Florame che consegna a questo indirizzo.',
      compareOneAlternative: 'Qui consegna un altro fiorista Florame.',
      compareMany: 'Scegli il fiorista più adatto al tuo regalo.',
      compareEmpty: 'Per ora nessun fiorista Florame consegna a questo indirizzo.',
      compareAddressRequired: 'Aggiungi l’indirizzo del destinatario per vedere chi può consegnare.',
      compareAddAddress: 'Aggiungi indirizzo',
      compareClose: 'Chiudi confronto fioristi',
      compareCurrent: 'Stai guardando questo',
      compareChoose: 'Scegli',
      bouquetExact: 'Questo bouquet è disponibile',
      bouquetUnavailable: 'Questo bouquet non è disponibile',
      bouquetUnknown: 'Bouquet da verificare',
      offerKicker: 'Scegli come riceverlo',
      offerTitle: 'Chi prepara il bouquet?',
      offerSubtitle: 'Ti mostriamo tutte le opzioni reali. La prima è quella che consigliamo.',
      offerRecommended: 'Consigliato',
      offerDelivery: 'Consegna al destinatario',
      offerPickup: 'Ritiro in negozio',
      offerChoose: 'Scegli questa opzione',
      offerOne: '1 opzione disponibile',
      offerMany: 'opzioni disponibili',
      offerFloristOne: '1 fiorista disponibile',
      offerFloristMany: 'fioristi disponibili',
      offerModeMany: 'modalità',
      offerEmpty: 'Nessun fiorista può preparare questo bouquet per la zona scelta.',
      offerGoneKicker: 'Bouquet non più in catalogo',
      offerGoneTitle: 'Ricreiamolo insieme',
      offerGoneSubtitle: 'Manteniamo lo stile e lo adattiamo ai fiori disponibili.',
      offerGoneStatus: 'Questa versione non è più acquistabile.',
      offerNotify: 'Avvisami quando torna',
      offerChangeAddress: 'Cambia indirizzo',
      promotionCart: 'Offerta del fiorista · applicata nel carrello'
    },
    en: {
      kicker: 'Florame partners',
      title: 'Explore partner florists',
      subtitle: 'Find the ateliers that can prepare or deliver a bouquet in your area.',
      placeholder: 'City, ZIP code or delivery address',
      search: 'Search',
      near: 'Near me',
      loading: 'Loading partners...',
      searching: 'Searching partners...',
      all: 'Active partners',
      coverage: 'Partners covering this address',
      city: 'Partners nearby',
      empty: 'No partner found for this search.',
      emptyHint: 'You can still create a bouquet and Florame will look for the best available coverage.',
      create: 'Create bouquet',
      open: 'Open storefront',
      covers: 'Covers address',
      pickup: 'Store pickup',
      delivery: 'Delivery',
      compactKicker: 'Your florist',
      compactTitle: 'A florist near you',
      compactSubtitle: 'Selected using your address and real availability.',
      viewAll: 'See other florists',
      collapse: 'Show less',
      stockLive: 'Stock updated',
      stockCoverageLive: 'Delivery available here',
      stockExpiring: 'Availability needs confirmation',
      stockEmpty: 'No bouquets available now',
      stockOffline: 'Temporarily unavailable',
      stockUnknown: 'Availability to be checked',
      newOnFlorame: 'New on Florame',
      verifiedOrder: 'verified order',
      verifiedOrders: 'verified orders',
      addressError: 'I cannot read this address. Try a city or ZIP code.',
      gpsError: 'Location unavailable. Enter an address or city.',
      disabled: 'Partner directory is not active.',
      results: 'results',
      oneResult: 'result',
      roma: 'Rome',
      coverageFallback: 'Coverage checked by ZIP'
      ,
      compareTitle: 'Florists delivering here',
      compareTitleNoAddress: 'Compare florists',
      compareSubtitle: 'Compare who can prepare and deliver the bouquet to the recipient.',
      compareChoiceKicker: 'Florist choice',
      compareChoiceTitle: 'Would you like another florist?',
      compareChoiceSubtitle: 'Compare partners freely before choosing where to continue.',
      compareCoverageKicker: 'Delivery not covered',
      compareCoverageTitle: 'This florist does not deliver here',
      compareCoverageSubtitle: 'We only show florists who can reach the recipient.',
      compareProductKicker: 'Bouquet to rediscover',
      compareProductTitle: 'Let’s find one you can actually buy',
      compareProductSubtitle: 'This older version is no longer on sale. We will find who can prepare a compatible one without sending you to a missing page.',
      compareProductEmpty: 'There is no identical ready-made version, but you can recreate this style.',
      compareCreateSimilar: 'Create a similar version',
      compareOnly: 'This is the only Florame florist delivering to this address.',
      compareOneAlternative: 'Another Florame florist delivers here.',
      compareMany: 'Choose the best florist for your gift.',
      compareEmpty: 'No Florame florist delivers to this address yet.',
      compareAddressRequired: 'Add the recipient address to see who can deliver.',
      compareAddAddress: 'Add address',
      compareClose: 'Close florist comparison',
      compareCurrent: 'You are viewing this',
      compareChoose: 'Choose',
      bouquetExact: 'This bouquet is available',
      bouquetUnavailable: 'This bouquet is unavailable',
      bouquetUnknown: 'Bouquet availability unknown',
      offerKicker: 'Choose how to receive it',
      offerTitle: 'Who will prepare the bouquet?',
      offerSubtitle: 'Here are all the real options. Our recommendation comes first.',
      offerRecommended: 'Recommended',
      offerDelivery: 'Delivery to recipient',
      offerPickup: 'Store pickup',
      offerChoose: 'Choose this option',
      offerOne: '1 option available',
      offerMany: 'options available',
      offerFloristOne: '1 florist available',
      offerFloristMany: 'florists available',
      offerModeMany: 'methods',
      offerEmpty: 'No florist can prepare this bouquet for the selected area.',
      offerGoneKicker: 'Bouquet no longer in the catalogue',
      offerGoneTitle: 'Let’s recreate it',
      offerGoneSubtitle: 'We’ll keep its style and adapt it to the flowers available.',
      offerGoneStatus: 'This version is no longer available to purchase.',
      offerNotify: 'Notify me when available',
      offerChangeAddress: 'Change address',
      promotionCart: 'Florist offer · applied in cart'
    }
  };

  var MOMENT_TEXT = {
    it: {
      dawn: ['Si comincia presto', 'Il giorno sboccia qui', 'Fiori freschi e mani già al lavoro.'],
      morning: ['Buongiorno dai fiori', 'La giornata parte in fiore', 'Scegli il bouquet che ti somiglia.'],
      midday: ['Freschi di giornata', 'Un fiore cambia il pranzo', 'Composizioni disponibili proprio ora.'],
      afternoon: ['Un pensiero al volo', 'Il pomeriggio merita colore', 'Fiori scelti e preparati dal tuo atelier.'],
      sunset: ['Ultimi raggi, nuovi fiori', 'La sera si fa più bella', 'C’è ancora tempo per sorprendere qualcuno.'],
      evening: ['Il negozio non dorme ancora', 'Fiori per domani, emozioni da oggi', 'Esplora con calma e prepara il prossimo gesto.'],
      expiring: ['Manca una piccola conferma', 'Questi fiori potrebbero cambiare', 'Lo stock è quasi da aggiornare.'],
      empty: ['Il vaso aspetta nuovi fiori', 'Nuovi bouquet in arrivo', 'Ora è tutto esaurito, ma torna presto.'],
      offline: ['Uffa, oggi siamo in pausa', 'I fiori riposano un po’', 'Il negozio tornerà dopo il prossimo aggiornamento.'],
      unknown: ['Stiamo guardando tra i fiori', 'Disponibilità in verifica', 'Un controllo veloce e sapremo cosa può fiorire oggi.']
    },
    en: {
      dawn: ['An early start', 'The day blooms here', 'Fresh flowers and hands already at work.'],
      morning: ['Good morning from the flowers', 'Start the day in bloom', 'Choose the bouquet that feels like you.'],
      midday: ['Fresh today', 'A flower changes lunch', 'Arrangements available right now.'],
      afternoon: ['A thoughtful surprise', 'The afternoon deserves colour', 'Flowers chosen by your atelier.'],
      sunset: ['Last light, new flowers', 'Make the evening lovelier', 'There is still time to surprise someone.'],
      evening: ['The shop is still dreaming', "Tomorrow's flowers start today", 'Explore slowly and plan your next gesture.'],
      expiring: ['One quick confirmation needed', 'These flowers may change', 'Stock is nearly due for an update.'],
      empty: ['The vase is waiting', 'New bouquets are coming', 'Sold out for now, but check back soon.'],
      offline: ['Oh no, we are taking a pause', 'The flowers are resting', 'The shop will return after its next update.'],
      unknown: ['Looking among the flowers', 'Checking availability', 'A quick check will tell us what can bloom today.']
    }
  };

  function lang() {
    try {
      if (window.FlorameI18n && typeof window.FlorameI18n.getLanguage === 'function') {
        return window.FlorameI18n.getLanguage() === 'en' ? 'en' : 'it';
      }
      var stored = localStorage.getItem('florame_native_lang') || localStorage.getItem('bouquetLanguage') || '';
      return String(stored || document.documentElement.lang || 'it').slice(0, 2).toLowerCase() === 'en' ? 'en' : 'it';
    } catch (_) {
      return 'it';
    }
  }

  function t(key) {
    var l = lang();
    return (TEXT[l] && TEXT[l][key]) || TEXT.it[key] || key;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function iconSvg(name) {
    var attrs = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';
    var icons = {
      search: '<svg ' + attrs + '><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
      locate: '<svg ' + attrs + '><path d="M12 2v3"/><path d="M12 19v3"/><path d="M2 12h3"/><path d="M19 12h3"/><circle cx="12" cy="12" r="5"/></svg>',
      arrow: '<svg ' + attrs + '><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>',
      check: '<svg ' + attrs + '><path d="M20 6 9 17l-5-5"/></svg>',
      store: '<svg ' + attrs + '><path d="m3 9 2-5h14l2 5"/><path d="M5 9v10h14V9"/><path d="M9 19v-5h6v5"/><path d="M3 9h18"/><path d="M8 9v3"/><path d="M12 9v3"/><path d="M16 9v3"/></svg>',
      truck: '<svg ' + attrs + '><path d="M10 17h4"/><path d="M3 6h11v11H3z"/><path d="M14 9h4l3 4v4h-3"/><circle cx="7" cy="17" r="2"/><circle cx="18" cy="17" r="2"/></svg>',
      bell: '<svg ' + attrs + '><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/><path d="M10 21h4"/></svg>',
      spark: '<svg ' + attrs + '><path d="M12 3l1.8 5.1L19 10l-5.2 1.9L12 17l-1.8-5.1L5 10l5.2-1.9L12 3z"/><path d="M5 19l.7-2 .8 2 2 .7-2 .8-.8 2-.7-2-2-.8 2-.7z"/></svg>'
    };
    return icons[name] || '';
  }

  function extractCap(value) {
    var match = String(value || '').match(/\b(\d{5})\b/);
    return match ? match[1] : '';
  }

  function normalizeCity(value) {
    return String(value || '')
      .replace(/\b\d{5}\b/g, '')
      .replace(/\b(italia|italy)\b/ig, '')
      .replace(/[,\s]+$/g, '')
      .replace(/^[,\s]+/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isPartnerRoute() {
    try {
      var cfg = window.__florameThemeConfig || {};
      if (String(cfg.currentPageTemplateSuffix || '') === 'partner-storefront') return true;
      var params = new URLSearchParams(window.location.search || '');
      if (params.get('partner') || params.get('partnerSlug')) return true;
      var path = window.location.pathname.replace(/^\/(it|en)(?=\/)/, '');
      var segments = path.split('/').filter(Boolean);
      if (segments.length === 1) {
        var reserved = ['account', 'apps', 'blog', 'blogs', 'cart', 'collections', 'pages', 'products', 'search'];
        return reserved.indexOf(segments[0].toLowerCase()) === -1;
      }
    } catch (_) {}
    return false;
  }

  function endpointUrl(endpoint, query) {
    var url = new URL(endpoint, window.location.origin);
    Object.keys(query || {}).forEach(function (key) {
      var value = query[key];
      if (value === undefined || value === null || value === '') return;
      url.searchParams.set(key, String(value));
    });
    return url.toString();
  }

  async function fetchJson(endpoint, query) {
    var response = await fetch(endpointUrl(endpoint, query), { headers: { Accept: 'application/json' } });
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok || data.success === false) throw new Error(data.error || response.statusText || 'request_failed');
    return data;
  }

  function getComponent(components, type) {
    var list = Array.isArray(components) ? components : [];
    for (var i = 0; i < list.length; i += 1) {
      var item = list[i] || {};
      var types = item.types || item.type || [];
      if (!Array.isArray(types)) types = [types];
      if (types.indexOf(type) !== -1) return item.longText || item.long_name || item.shortText || item.short_name || '';
    }
    return '';
  }

  async function resolveAddressQuery(query) {
    var clean = String(query || '').trim();
    if (!clean) return {};
    var directCap = extractCap(clean);
    if (directCap) {
      return { cap: directCap, address: clean, city: normalizeCity(clean) };
    }

    try {
      var sessionToken = 'pd_' + Date.now().toString(36) + Math.random().toString(16).slice(2);
      var autocomplete = await fetchJson(CONFIG.addressAutocompleteEndpoint, {
        q: clean,
        limit: 1,
        country: 'IT',
        sessionToken: sessionToken
      });
      var list = Array.isArray(autocomplete.suggestions) ? autocomplete.suggestions : [];
      var first = list[0] || null;
      if (first && first.placeId) {
        var resolved = await fetchJson(CONFIG.addressResolveEndpoint, {
          placeId: first.placeId,
          country: 'IT',
          sessionToken: sessionToken
        });
        var place = resolved.place || {};
        var display = String(place.formattedAddress || place.display || first.text || clean).trim();
        var cap = extractCap(place.postcode || place.postalCode || display);
        var city = getComponent(place.addressComponents, 'locality')
          || getComponent(place.addressComponents, 'postal_town')
          || getComponent(place.addressComponents, 'administrative_area_level_3')
          || normalizeCity(display);
        return {
          cap: cap,
          city: normalizeCity(city),
          address: display,
          lat: place.lat || '',
          lng: place.lng || ''
        };
      }
    } catch (_) {}

    return { city: normalizeCity(clean), address: clean };
  }

  function readSavedCapState() {
    try {
      var state = JSON.parse(localStorage.getItem('florame_cap_state') || '{}');
      if (!state || !(state.verified || state.addressVerified) || !state.cap) return null;
      var ts = Number(state.ts || state.savedAt || 0);
      if (ts && Date.now() - ts > 2 * 60 * 60 * 1000) return null;
      return { cap: String(state.cap || ''), address: String(state.display || state.address || state.cap || '') };
    } catch (_) {
      return null;
    }
  }

  function initials(name) {
    return String(name || 'F')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) { return part.charAt(0).toUpperCase(); })
      .join('') || 'F';
  }

  function statusText(data) {
    var q = data && data.query ? data.query : {};
    var total = Number(data && data.total || 0);
    var countLabel = total === 1 ? t('oneResult') : t('results');
    if (q.mode === 'coverage') return t('coverage') + ' - ' + total + ' ' + countLabel;
    if (q.mode === 'city') return t('city') + (q.city ? ' - ' + String(q.city) : '') + ' - ' + total + ' ' + countLabel;
    if (q.mode === 'search') return t('all') + ' - ' + total + ' ' + countLabel;
    return t('all') + ' - ' + total + ' ' + countLabel;
  }

  function safeAccent(value) {
    var clean = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(clean) ? clean : '#d92f68';
  }

  function availabilityState(partner) {
    var state = String(partner && partner.availability && partner.availability.state || 'unknown').toLowerCase();
    return ['live', 'expiring', 'empty', 'offline'].indexOf(state) !== -1 ? state : 'unknown';
  }

  function availabilityLabel(partner, mode) {
    var state = availabilityState(partner);
    if (state === 'live' && mode === 'coverage' && partner.coversAddress && partner.deliveryEnabled) return t('stockCoverageLive');
    if (state === 'live') return t('stockLive');
    if (state === 'expiring') return t('stockExpiring');
    if (state === 'empty') return t('stockEmpty');
    if (state === 'offline') return t('stockOffline');
    return t('stockUnknown');
  }

  function reviewAggregate(partner) {
    if (!partner || typeof partner !== 'object') return null;
    var source = partner.reviewAggregate
      || partner.reviewsAggregate
      || partner.reputation && (partner.reputation.aggregate || partner.reputation)
      || partner.reviewStats
      || null;
    if (!source || typeof source !== 'object') return null;
    return {
      average: Math.max(0, Math.min(5, Number(source.average || source.averageRating || source.rating || 0) || 0)),
      count: Math.max(0, Math.round(Number(source.ratingCount || source.reviewCount || source.count || source.total || 0) || 0))
    };
  }

  function reviewLabel(partner) {
    var aggregate = reviewAggregate(partner);
    if (!aggregate) return '';
    if (!aggregate.count) return t('newOnFlorame');
    if (aggregate.count < 5 || !aggregate.average) {
      return aggregate.count + ' ' + t(aggregate.count === 1 ? 'verifiedOrder' : 'verifiedOrders');
    }
    var locale = lang() === 'en' ? 'en-US' : 'it-IT';
    return '★ ' + aggregate.average.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
      + ' · ' + aggregate.count + ' ' + t(aggregate.count === 1 ? 'verifiedOrder' : 'verifiedOrders');
  }

  function resolveCardMoment(partner) {
    var state = availabilityState(partner);
    var key = ['expiring', 'empty', 'offline', 'unknown'].indexOf(state) !== -1 ? state : '';
    if (!key) {
      var hour = new Date().getHours();
      if (hour >= 5 && hour < 8) key = 'dawn';
      else if (hour < 11) key = 'morning';
      else if (hour < 14) key = 'midday';
      else if (hour < 18) key = 'afternoon';
      else if (hour < 21) key = 'sunset';
      else key = 'evening';
    }
    var locale = lang();
    var copy = MOMENT_TEXT[locale][key] || MOMENT_TEXT.it[key];
    var assets = window.__florameThemeConfig && window.__florameThemeConfig.partnerCardAssets || {};
    return { key: key, eyebrow: copy[0], title: copy[1], body: copy[2], assetUrl: assets[key] || '', dark: key === 'evening' || key === 'offline' };
  }

  function partnerCard(partner, mode, options) {
    var compact = !!(options && options.compact);
    var currentSlug = String(options && options.currentSlug || '').toLowerCase();
    var rowSlug = String(partner && partner.partnerSlug || '').toLowerCase();
    var isCurrent = !!currentSlug && rowSlug === currentSlug;
    var href = partner.homeUrl || '/pages/home';
    var logo = partner.logoUrl
      ? '<img src="' + escapeHtml(partner.logoUrl) + '" alt="' + escapeHtml(partner.name || '') + '" loading="lazy" decoding="async">'
      : '<span>' + escapeHtml(initials(partner.name)) + '</span>';
    var promotionPercentage = partner.cartPromotion && partner.cartPromotion.enabled
      ? Number(partner.cartPromotion.percentage)
      : 0;
    var promotionHtml = promotionPercentage > 0
      ? '<span class="florame-partner-directory-promotion"><strong>-' + escapeHtml(promotionPercentage.toLocaleString(lang() === 'en' ? 'en-US' : 'it-IT')) + '%</strong><span>' + escapeHtml(t('promotionCart')) + '</span></span>'
      : '';
    var badges = [];
    if (mode === 'coverage' && partner.coversAddress) badges.push(t('covers'));
    if (partner.pickupEnabled) badges.push(t('pickup'));
    if (partner.deliveryEnabled) badges.push(t('delivery'));
    (Array.isArray(partner.badges) ? partner.badges : []).slice(0, 2).forEach(function (badge) { badges.push(badge); });
    var badgeHtml = badges.slice(0, 3).map(function (badge, index) {
      return '<span class="florame-partner-directory-badge ' + (index === 0 ? 'is-primary' : '') + '">' + (index === 0 ? iconSvg('check') : '') + '<span>' + escapeHtml(badge) + '</span></span>';
    }).join('');
    var localityParts = [partner.city, partner.province || partner.region].filter(function (value, index, values) {
      var normalized = String(value || '').trim().toLowerCase();
      return normalized && values.findIndex(function (candidate) {
        return String(candidate || '').trim().toLowerCase() === normalized;
      }) === index;
    });
    var meta = compact
      ? localityParts.join(' · ')
      : [partner.city, partner.coverageSummary].filter(Boolean).join(' · ');
    var description = partner.servicePromise || partner.description || partner.addressLine || meta || t('coverageFallback');
    var state = availabilityState(partner);
    var serviceLabels = [partner.deliveryEnabled ? t('delivery') : '', partner.pickupEnabled ? t('pickup') : ''].filter(Boolean);
    var moment = resolveCardMoment(partner);
    var reputation = reviewLabel(partner);
    var bouquetMatchState = String(partner && partner.bouquetMatch && partner.bouquetMatch.state || '');
    var bouquetMatch = bouquetMatchState
      ? '<span class="florame-partner-directory-bouquet-match is-' + escapeHtml(bouquetMatchState) + '">' +
          escapeHtml(t(bouquetMatchState === 'exact'
            ? 'bouquetExact'
            : (bouquetMatchState === 'unavailable' ? 'bouquetUnavailable' : 'bouquetUnknown'))) +
        '</span>'
      : '';
    var cardTag = isCurrent ? 'div' : 'a';
    var navigationAttributes = isCurrent
      ? ' aria-current="true"'
      : ' href="' + escapeHtml(href) + '" aria-label="' + escapeHtml(t('compareChoose') + ': ' + (partner.name || '')) + '"';

    return '' +
      '<' + cardTag + ' class="florame-partner-directory-item is-' + escapeHtml(state) + ' is-moment-' + escapeHtml(moment.key) + (moment.dark ? ' is-dark-moment' : '') + (compact ? ' is-compact' : '') + (isCurrent ? ' is-current-partner' : '') + (bouquetMatchState ? ' has-bouquet-match' : '') + '" data-partner-slug="' + escapeHtml(rowSlug) + '" style="--fpd-partner-accent:' + escapeHtml(safeAccent(partner.accentColor)) + ';--fpd-card-art:url(&quot;' + escapeHtml(moment.assetUrl) + '&quot;)"' + navigationAttributes + '>' +
        '<span class="florame-partner-directory-art" aria-hidden="true"></span>' +
        '<span class="florame-partner-directory-content">' +
          '<span class="florame-partner-directory-brand"><span class="florame-partner-directory-logo">' + logo + '</span><span><strong>' + escapeHtml(partner.name || '') + '</strong><em>' + escapeHtml(meta || partner.city || '') + '</em></span></span>' +
          '<span class="florame-partner-directory-moment"><small>' + escapeHtml(moment.eyebrow) + '</small><b>' + escapeHtml(moment.title) + '</b><span>' + escapeHtml(partner.servicePromise || moment.body || description) + '</span></span>' +
          '<span class="florame-partner-directory-availability is-' + escapeHtml(state) + '"><i aria-hidden="true"></i>' + escapeHtml(availabilityLabel(partner, mode)) + '</span>' +
          promotionHtml +
          (reputation ? '<span class="florame-partner-directory-reputation">' + escapeHtml(reputation) + '</span>' : '') +
          bouquetMatch +
          (isCurrent ? '<span class="florame-partner-directory-current">' + iconSvg('check') + '<span>' + escapeHtml(t('compareCurrent')) + '</span></span>' : '') +
          (compact && serviceLabels.length ? '<span class="florame-partner-directory-services">' + escapeHtml(serviceLabels.join(' · ')) + '</span>' : '') +
          (!compact ? '<span class="florame-partner-directory-badges">' + badgeHtml + '</span>' : '') +
        '</span>' +
        (!isCurrent ? '<span class="florame-partner-directory-arrow" aria-hidden="true">' + iconSvg('arrow') + '</span>' : '') +
      '</' + cardTag + '>';
  }

  function includeQaFixtures() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return ['1', 'true', 'yes'].indexOf(String(params.get('qaPartners') || params.get('florameQaPartners') || '').toLowerCase()) !== -1;
    } catch (_) {
      return false;
    }
  }

  function groupOffersByPartner(offers) {
    var groups = [];
    var byPartner = new Map();
    (Array.isArray(offers) ? offers : []).forEach(function (offer, index) {
      var partner = offer && offer.partner || {};
      var key = String(partner.partnerSlug || partner.id || partner.name || 'partner-' + index).trim().toLowerCase();
      var group = byPartner.get(key);
      if (!group) {
        group = { partner: partner, offers: [] };
        byPartner.set(key, group);
        groups.push(group);
      }
      group.offers.push({ offer: offer, index: index });
    });
    return groups;
  }

  function offerGroupCard(group, groupIndex) {
    var partner = group && group.partner || {};
    var recommended = groupIndex === 0;
    var logo = partner.logoUrl
      ? '<img src="' + escapeHtml(partner.logoUrl) + '" alt="" loading="eager" decoding="async">'
      : '<span>' + escapeHtml(initials(partner.name)) + '</span>';
    var promotionPercentage = partner.cartPromotion && partner.cartPromotion.enabled
      ? Number(partner.cartPromotion.percentage)
      : 0;
    var promotion = promotionPercentage > 0
      ? '<span class="florame-partner-offer-promotion"><strong>-' + escapeHtml(promotionPercentage.toLocaleString(lang() === 'en' ? 'en-US' : 'it-IT')) + '%</strong><span>' + escapeHtml(t('promotionCart')) + '</span></span>'
      : '';
    var methods = (group && Array.isArray(group.offers) ? group.offers : []).map(function (entry) {
      var offer = entry.offer || {};
      var pickup = String(offer.fulfillmentType || '') === 'pickup';
      var place = [partner.city, pickup ? partner.addressLine : ''].filter(Boolean).join(' · ');
      return '' +
        '<button type="button" class="florame-partner-offer-method" data-florame-offer-index="' + entry.index + '">' +
          '<span class="florame-partner-offer-mode">' + (pickup ? iconSvg('store') : iconSvg('truck')) +
            '<span><b>' + escapeHtml(t(pickup ? 'offerPickup' : 'offerDelivery')) + '</b>' +
            (place ? '<small>' + escapeHtml(place) + '</small>' : '') + '</span>' +
          '</span>' +
          '<span class="florame-partner-offer-action" aria-hidden="true">' + iconSvg('arrow') + '</span>' +
        '</button>';
    }).join('');
    return '' +
      '<section class="florame-partner-offer' + (recommended ? ' is-recommended' : '') + '">' +
        '<div class="florame-partner-offer-head">' +
          '<span class="florame-partner-offer-logo">' + logo + '</span>' +
          '<div class="florame-partner-offer-copy">' +
            '<div class="florame-partner-offer-topline">' +
              '<strong>' + escapeHtml(partner.name || '') + '</strong>' +
              (recommended ? '<em>' + iconSvg('spark') + escapeHtml(t('offerRecommended')) + '</em>' : '') +
            '</div>' +
            promotion +
          '</div>' +
        '</div>' +
        '<div class="florame-partner-offer-methods">' + methods + '</div>' +
      '</section>';
  }

  var offerResolutionCache = new Map();

  async function resolveOffers(detail) {
    var info = detail && typeof detail === 'object' ? detail : {};
    var saved = readSavedCapState() || {};
    var productIds = Array.from(new Set(
      (Array.isArray(info.productIds) ? info.productIds : [info.productId])
        .map(function (value) { return String(value || '').trim(); })
        .filter(Boolean)
    )).slice(0, 24);
    if (!productIds.length) return { resolutions: {}, resolution: null };
    var cap = String(info.cap || saved.cap || '').trim();
    var address = String(info.address || info.display || saved.address || '').trim();
    var currentSlug = currentPartnerSlug(info);
    var deliveryIntent = readStoredDeliveryIntent();
    try {
      deliveryIntent = Object.assign(deliveryIntent, window.FlorameDeliveryIntent?.toQuery?.() || {});
    } catch (_) {}
    var qaFixtures = includeQaFixtures();
    var intentSignature = '';
    try { intentSignature = window.FlorameDeliveryIntent?.signature?.() || ''; } catch (_) {}
    if (!intentSignature) intentSignature = [deliveryIntent.selectedDate || 'no-date', deliveryIntent.selectedTimeSlot || 'no-slot'].join('|');
    var cacheKey = [productIds.join(','), cap, address, currentSlug, intentSignature, qaFixtures ? 'qa' : 'live'].join('|');
    var cached = offerResolutionCache.get(cacheKey);
    if (cached && Date.now() - cached.savedAt < 30000) return cached.data;
    var data = await fetchJson(CONFIG.directoryEndpoint, {
      mode: 'compare',
      cap: cap,
      address: address,
      lat: info.lat || '',
      lng: info.lng || '',
      productIds: productIds.join(','),
      currentPartnerSlug: currentSlug,
      deliveryType: deliveryIntent.deliveryType || info.deliveryType || 'delivery',
      selectedDate: deliveryIntent.selectedDate || info.selectedDate || '',
      selectedTimeSlot: deliveryIntent.selectedTimeSlot || info.selectedTimeSlot || '',
      postalCode: deliveryIntent.postalCode || cap,
      latitude: deliveryIntent.latitude || info.lat || '',
      longitude: deliveryIntent.longitude || info.lng || '',
      includeQaFixtures: qaFixtures ? '1' : '',
      limit: 40
    });
    offerResolutionCache.set(cacheKey, { savedAt: Date.now(), data: data });
    return data;
  }

  function shell(surface) {
    var compactHome = surface === 'app-home';
    return '' +
      '<article class="florame-partner-directory-card' + (compactHome ? ' is-compact-home' : '') + '" data-partner-directory-card>' +
        '<div class="florame-partner-directory-head">' +
          '<div>' +
            '<div class="florame-partner-directory-kicker">' + escapeHtml(t(compactHome ? 'compactKicker' : 'kicker')) + '</div>' +
            '<h2>' + escapeHtml(t(compactHome ? 'compactTitle' : 'title')) + '</h2>' +
            '<p>' + escapeHtml(t(compactHome ? 'compactSubtitle' : 'subtitle')) + '</p>' +
          '</div>' +
          '<div class="florame-partner-directory-mark" aria-hidden="true">' +
            '<svg viewBox="0 0 120 120" fill="none" focusable="false">' +
              '<path d="M18 51 60 27l42 24-42 24-42-24Z" fill="rgba(255,255,255,.92)" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M26 57v26l34 19 34-19V57" fill="rgba(255,77,117,.11)" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M60 75v27" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M42 49h36" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M48 40h24" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M87 24l3-8 3 8 8 3-8 3-3 8-3-8-8-3 8-3Z" fill="currentColor"/>' +
            '</svg>' +
          '</div>' +
        '</div>' +
        '<form class="florame-partner-directory-search" data-partner-directory-form>' +
          '<label class="florame-partner-directory-field">' +
            '<span class="sr-only">' + escapeHtml(t('placeholder')) + '</span>' +
            '<input type="text" autocomplete="street-address" inputmode="text" placeholder="' + escapeHtml(t('placeholder')) + '" data-partner-directory-input>' +
          '</label>' +
          '<button type="submit" class="florame-partner-directory-button is-search"><span class="florame-partner-directory-button-icon">' + iconSvg('search') + '</span><span>' + escapeHtml(t('search')) + '</span></button>' +
          '<button type="button" class="florame-partner-directory-button is-geo" data-partner-directory-geo><span class="florame-partner-directory-button-icon">' + iconSvg('locate') + '</span><span>' + escapeHtml(t('near')) + '</span></button>' +
        '</form>' +
        '<div class="florame-partner-directory-status" data-partner-directory-status>' + escapeHtml(t('loading')) + '</div>' +
        '<div class="florame-partner-directory-results" data-partner-directory-results data-surface="' + escapeHtml(surface || '') + '"></div>' +
        (compactHome ? '<button type="button" class="florame-partner-directory-expand" data-partner-directory-expand aria-expanded="false">' + escapeHtml(t('viewAll')) + '</button>' : '') +
      '</article>';
  }

  function renderLoading(root, message) {
    var status = root.querySelector('[data-partner-directory-status]');
    var results = root.querySelector('[data-partner-directory-results]');
    if (status) status.textContent = message || t('loading');
    if (results) {
      var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
      var skeletonCount = surface === 'app-home' && root.getAttribute('data-directory-expanded') !== 'true' ? 1 : 3;
      results.innerHTML = Array.from({ length: skeletonCount }).map(function () {
        return '<div class="florame-partner-directory-item is-skeleton" aria-hidden="true"><span></span><div><i></i><i></i><i></i><i></i></div></div>';
      }).join('');
    }
  }

  function isSurfaceEnabled(root, data) {
    var settings = data && data.partnerDirectorySettings ? data.partnerDirectorySettings : {};
    if (data && data.enabled === false) return false;
    if (settings && settings.enabled === false) return false;
    var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
    if (surface === 'landing') return !settings || settings.landingEnabled !== false;
    if (surface === 'app-home') return !settings || settings.appHomeEnabled !== false;
    return true;
  }

  function renderData(root, data) {
    var status = root.querySelector('[data-partner-directory-status]');
    var results = root.querySelector('[data-partner-directory-results]');
    var section = root.closest('[data-florame-partner-directory-section]');
    if (!isSurfaceEnabled(root, data)) {
      root.hidden = true;
      if (section) section.hidden = true;
      return;
    }
    root.hidden = false;
    if (section) section.hidden = false;
    root.__floramePartnerDirectoryData = data || {};
    if (status) status.textContent = statusText(data || {});
    var partners = Array.isArray(data && data.partners) ? data.partners : [];
    var mode = data && data.query ? data.query.mode : 'all';
    var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
    var compactHome = surface === 'app-home' && root.getAttribute('data-directory-expanded') !== 'true';
    if (compactHome) partners = partners.filter(function (partner) {
      return !partner.visibility || partner.visibility.homeFeatured !== false;
    }).slice(0, 1);
    if (!results) return;
    if (!partners.length) {
      results.innerHTML = '' +
        '<div class="florame-partner-directory-empty">' +
          '<strong>' + escapeHtml(t('empty')) + '</strong>' +
          '<span>' + escapeHtml(t('emptyHint')) + '</span>' +
          '<a href="/pages/florame-app?mode=create">' + escapeHtml(t('create')) + '</a>' +
        '</div>';
      return;
    }
    results.innerHTML = partners.map(function (partner) { return partnerCard(partner, mode, { compact: compactHome }); }).join('');
  }

  async function loadDirectory(root, params, message) {
    try {
      renderLoading(root, message || t('loading'));
      var data = await fetchJson(CONFIG.directoryEndpoint, Object.assign({
        limit: 12,
        includeQaFixtures: includeQaFixtures() ? '1' : ''
      }, params || {}));
      renderData(root, data);
    } catch (error) {
      var status = root.querySelector('[data-partner-directory-status]');
      var results = root.querySelector('[data-partner-directory-results]');
      if (status) status.textContent = t('addressError');
      if (results) results.innerHTML = '';
    }
  }

  var compareSheet = null;
  var compareLastFocus = null;
  var compareBodyOverflow = '';
  var comparePendingDetail = null;
  var compareCurrentDetail = null;

  function currentPartnerSlug(detail) {
    var explicit = String(detail && (detail.currentPartnerSlug || detail.partnerSlug) || '').trim();
    if (explicit) return explicit.toLowerCase();
    try {
      var params = new URLSearchParams(window.location.search || '');
      var fromQuery = params.get('partner') || params.get('partnerSlug') || '';
      if (fromQuery) return String(fromQuery).toLowerCase();
      var context = window.FloramePartner && window.FloramePartner.getContext
        ? window.FloramePartner.getContext()
        : null;
      return String(context && (context.partnerSlug || context.slug) || '').toLowerCase();
    } catch (_) {
      return '';
    }
  }

  function ensureCompareSheet() {
    if (compareSheet && document.documentElement.contains(compareSheet)) return compareSheet;
    var overlay = document.createElement('div');
    overlay.className = 'florame-partner-compare';
    overlay.hidden = true;
    overlay.innerHTML = '' +
      '<button class="florame-partner-compare-backdrop" type="button" data-partner-compare-close aria-label="' + escapeHtml(t('compareClose')) + '"></button>' +
      '<section class="florame-partner-compare-sheet" role="dialog" aria-modal="true" aria-labelledby="florame-partner-compare-title">' +
        '<div class="florame-partner-compare-handle" data-partner-compare-handle aria-hidden="true"><span></span></div>' +
        '<header class="florame-partner-compare-head">' +
          '<div><span class="florame-partner-compare-kicker" data-partner-compare-kicker>Florame</span><h2 id="florame-partner-compare-title"></h2><p data-partner-compare-subtitle></p></div>' +
          '<button class="florame-partner-compare-close" type="button" data-partner-compare-close aria-label="' + escapeHtml(t('compareClose')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button>' +
        '</header>' +
        '<div class="florame-partner-compare-context" data-partner-compare-context></div>' +
        '<div class="florame-partner-compare-status" data-partner-compare-status aria-live="polite"></div>' +
        '<div class="florame-partner-compare-results" data-partner-compare-results></div>' +
      '</section>';
    document.body.appendChild(overlay);
    compareSheet = overlay;

    function closeCompare(options) {
      if (!compareSheet || compareSheet.hidden) return;
      var continuation = options && options.continuation === true;
      var closedDetail = compareCurrentDetail;
      compareSheet.classList.remove('is-open');
      window.setTimeout(function () {
        if (!compareSheet) return;
        compareSheet.hidden = true;
        document.body.style.overflow = compareBodyOverflow;
        if (compareLastFocus && typeof compareLastFocus.focus === 'function') compareLastFocus.focus();
        if (!continuation) {
          window.dispatchEvent(new CustomEvent('florame:partner-compare-closed', {
            detail: closedDetail || {}
          }));
        }
        if (compareCurrentDetail === closedDetail) compareCurrentDetail = null;
      }, 220);
    }

    overlay.querySelectorAll('[data-partner-compare-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeCompare(); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && compareSheet && !compareSheet.hidden) closeCompare();
    });

    var handle = overlay.querySelector('[data-partner-compare-handle]');
    var panel = overlay.querySelector('.florame-partner-compare-sheet');
    var startY = 0;
    var dragY = 0;
    var dragging = false;
    function dragStart(event) {
      dragging = true;
      startY = Number(event.clientY || 0);
      dragY = 0;
      panel.classList.add('is-dragging');
      try { handle.setPointerCapture(event.pointerId); } catch (_) {}
    }
    function dragMove(event) {
      if (!dragging) return;
      dragY = Math.max(0, Number(event.clientY || 0) - startY);
      panel.style.transform = 'translate3d(0,' + Math.min(dragY, 260) + 'px,0)';
    }
    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      panel.classList.remove('is-dragging');
      panel.style.transform = '';
      if (dragY > 90) closeCompare();
      dragY = 0;
    }
    if (handle) {
      handle.addEventListener('pointerdown', dragStart);
      handle.addEventListener('pointermove', dragMove);
      handle.addEventListener('pointerup', dragEnd);
      handle.addEventListener('pointercancel', dragEnd);
    }
    overlay.__closeFlorameCompare = closeCompare;
    return overlay;
  }

  async function openCompare(detail) {
    var overlay = ensureCompareSheet();
    var info = detail && typeof detail === 'object' ? detail : {};
    compareCurrentDetail = info;
    var saved = readSavedCapState() || {};
    var cap = String(info.cap || saved.cap || '').trim();
    var address = String(info.address || info.display || saved.address || '').trim();
    var currentSlug = currentPartnerSlug(info);
    var compareSource = String(info.source || '').trim().toLowerCase();
    var compareIntent = String(info.intent || info.compareIntent || '').trim().toLowerCase();
    var commerceMissing = info.commerceMissing === true || String(info.commerceMissing || '') === '1';
    var productIntent = compareIntent === 'product'
      || compareIntent === 'offer'
      || compareIntent === 'purchase'
      || !!String(info.productId || '').trim()
      || !!info.offerResolution;
    var coverageFailure = compareIntent === 'coverage'
      || String(info.coverageState || '').trim().toLowerCase() === 'uncovered'
      || compareSource === 'coverage-failed'
      || compareSource === 'bouquet-outside-coverage'
      || compareSource === 'pdp-coverage'
      || compareSource === 'pdp-coverage-failed';
    var kicker = overlay.querySelector('[data-partner-compare-kicker]');
    var title = overlay.querySelector('#florame-partner-compare-title');
    var subtitle = overlay.querySelector('[data-partner-compare-subtitle]');
    var context = overlay.querySelector('[data-partner-compare-context]');
    var status = overlay.querySelector('[data-partner-compare-status]');
    var results = overlay.querySelector('[data-partner-compare-results]');

    compareLastFocus = document.activeElement;
    compareBodyOverflow = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';
    overlay.hidden = false;
    overlay.setAttribute('data-compare-intent', productIntent ? 'product' : (coverageFailure ? 'coverage' : 'choice'));
    window.requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    if (kicker) kicker.textContent = t(commerceMissing ? 'offerGoneKicker' : (productIntent ? 'offerKicker' : (coverageFailure ? 'compareCoverageKicker' : 'compareChoiceKicker')));
    if (title) title.textContent = t(commerceMissing ? 'offerGoneTitle' : (productIntent ? 'offerTitle' : (coverageFailure ? 'compareCoverageTitle' : 'compareChoiceTitle')));
    if (subtitle) subtitle.textContent = t(commerceMissing ? 'offerGoneSubtitle' : (productIntent ? 'offerSubtitle' : (coverageFailure ? 'compareCoverageSubtitle' : 'compareChoiceSubtitle')));
    if (context) context.textContent = [String(info.productName || '').trim(), address || cap || ''].filter(Boolean).join(' · ');
    if (status) status.textContent = cap ? t('searching') : t('compareAddressRequired');
    if (results) results.innerHTML = '';

    var close = overlay.querySelector('.florame-partner-compare-close');
    if (close) window.setTimeout(function () { close.focus(); }, 60);

    if (!cap && !commerceMissing) {
      comparePendingDetail = info;
      if (results) {
        results.innerHTML = '<button type="button" class="florame-partner-compare-address" data-partner-compare-address>' +
          iconSvg('locate') + '<span>' + escapeHtml(t('compareAddAddress')) + '</span></button>';
        var addressButton = results.querySelector('[data-partner-compare-address]');
        if (addressButton) addressButton.addEventListener('click', function () {
          if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare({ continuation: true });
          window.setTimeout(function () {
            if (window.FlorameHomeAddress && typeof window.FlorameHomeAddress.open === 'function') {
              window.FlorameHomeAddress.open({ source: 'partner-compare', scroll: true, focus: true });
              return;
            }
            var trigger = document.querySelector('[data-home-address-trigger="header"], [data-home-address-trigger]');
            if (trigger) trigger.click();
          }, 240);
        });
      }
      return;
    }
    comparePendingDetail = null;

    try {
      var data = commerceMissing
        ? { partners: [], resolutions: {}, resolution: null }
        : productIntent
        ? await resolveOffers(info)
        : await fetchJson(CONFIG.directoryEndpoint, {
            mode: 'compare',
            cap: cap,
            address: address,
            lat: info.lat || '',
            lng: info.lng || '',
            productId: info.productId || '',
            currentPartnerSlug: currentSlug,
            includeQaFixtures: includeQaFixtures() ? '1' : '',
            limit: 20
          });
      var resolution = commerceMissing
        ? { productId: String(info.productId || '').trim(), state: 'commerce_missing', offers: [] }
        : info.offerResolution
        || data.resolution
        || data.resolutions && data.resolutions[String(info.productId || '').trim()]
        || null;
      var offers = resolution && Array.isArray(resolution.offers) ? resolution.offers : [];
      var offerGroups = groupOffersByPartner(offers);
      var currentPartner = currentSlug
        ? (Array.isArray(data.partners) ? data.partners : []).find(function (partner) {
            return String(partner && partner.partnerSlug || '').trim().toLowerCase() === currentSlug;
          })
        : null;
      var currentProductId = String(info.productId || resolution && resolution.productId || '').trim();
      var currentBouquetMatch = currentPartner && currentProductId
        ? currentPartner.bouquetMatches && currentPartner.bouquetMatches[currentProductId]
        : currentPartner && currentPartner.bouquetMatch;
      var canNotifyCurrent = !!(
        currentPartner
        && String(currentBouquetMatch && currentBouquetMatch.state || '').toLowerCase() === 'unavailable'
      );
      if (productIntent && resolution) {
        if (status) {
          status.textContent = commerceMissing
            ? t('offerGoneStatus')
            : (offerGroups.length === 1
              ? t('offerFloristOne') + (offers.length > 1 ? ' · ' + offers.length + ' ' + t('offerModeMany') : '')
              : (offerGroups.length ? offerGroups.length + ' ' + t('offerFloristMany') : t('offerEmpty')));
        }
        if (results) {
          results.innerHTML = offerGroups.map(function (group, index) {
            return offerGroupCard(group, index);
          }).join('') +
            (!offers.length && !commerceMissing
              ? '<button type="button" class="florame-partner-compare-address" data-partner-compare-address>' +
                  iconSvg('locate') + '<span>' + escapeHtml(t('offerChangeAddress')) + '</span></button>'
              : '') +
            (canNotifyCurrent
              ? '<button type="button" class="florame-partner-compare-notify" data-partner-offer-notify>' +
                  iconSvg('bell') + '<span>' + escapeHtml(t('offerNotify')) + '</span></button>'
              : '') +
            '<button type="button" class="florame-partner-compare-create" data-partner-compare-create>' +
              iconSvg('arrow') + '<span>' + escapeHtml(t('compareCreateSimilar')) + '</span></button>';
          results.querySelectorAll('[data-florame-offer-index]').forEach(function (button) {
            button.addEventListener('click', function () {
              var offer = offers[Number(button.getAttribute('data-florame-offer-index') || 0)] || null;
              if (!offer) return;
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare({ continuation: true });
              window.setTimeout(function () {
                window.dispatchEvent(new CustomEvent('florame:bouquet-offer-selected', {
                  detail: {
                    offer: offer,
                    resolution: resolution,
                    productId: String(info.productId || offer.productId || ''),
                    variantId: String(info.variantId || offer.variantId || ''),
                    handle: String(info.handle || offer.handle || ''),
                    productName: String(info.productName || offer.bouquetName || ''),
                    button: info.button || null,
                    suppressAutoAdd: info.suppressAutoAdd === true,
                    source: String(info.source || 'offer-sheet')
                  }
                }));
              }, 230);
            });
          });
          var addressButton = results.querySelector('[data-partner-compare-address]');
          if (addressButton) addressButton.addEventListener('click', function () {
            if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
            window.setTimeout(function () {
              if (window.FlorameHomeAddress && typeof window.FlorameHomeAddress.open === 'function') {
                window.FlorameHomeAddress.open({ source: 'bouquet-offer-empty', scroll: true, focus: true });
              }
            }, 240);
          });
          var notifyButton = results.querySelector('[data-partner-offer-notify]');
          if (notifyButton) notifyButton.addEventListener('click', function () {
            if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
            window.setTimeout(function () {
              window.dispatchEvent(new CustomEvent('florame:bouquet-offer-notify', {
                detail: {
                  productId: currentProductId,
                  variantId: String(info.variantId || ''),
                  handle: String(info.handle || ''),
                  productName: String(info.productName || ''),
                  partner: currentPartner,
                  button: info.button || null,
                  source: String(info.source || 'offer-sheet')
                }
              }));
            }, 230);
          });
          var createOfferButton = results.querySelector('[data-partner-compare-create]');
          if (createOfferButton) createOfferButton.addEventListener('click', function () {
            var bouquetData = String(info.bouquetData || '');
            if (bouquetData && typeof window.homeEditBouquet === 'function') {
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
              window.setTimeout(function () { window.homeEditBouquet(bouquetData); }, 220);
              return;
            }
            var destination = window.FloramePartner && typeof window.FloramePartner.appUrl === 'function'
              ? window.FloramePartner.appUrl('custom')
              : '/pages/florame-app?mode=custom';
            window.location.assign(destination);
          });
        }
        return;
      }
      var partners = Array.isArray(data.partners) ? data.partners.slice() : [];
      if (productIntent) {
        partners = partners.filter(function (partner) {
          var slug = String(partner && partner.partnerSlug || '').toLowerCase();
          var match = String(partner && partner.bouquetMatch && partner.bouquetMatch.state || '').toLowerCase();
          return slug !== currentSlug && match !== 'unavailable';
        });
      }
      partners.sort(function (left, right) {
        var leftCurrent = String(left && left.partnerSlug || '').toLowerCase() === currentSlug ? 1 : 0;
        var rightCurrent = String(right && right.partnerSlug || '').toLowerCase() === currentSlug ? 1 : 0;
        return rightCurrent - leftCurrent;
      });
      if (status) {
        if (!partners.length) status.textContent = t(productIntent ? 'compareProductEmpty' : 'compareEmpty');
        else if (partners.length === 1 && String(partners[0].partnerSlug || '').toLowerCase() === currentSlug) status.textContent = t('compareOnly');
        else if (partners.length === 1) status.textContent = t('compareOneAlternative');
        else status.textContent = t('compareMany');
      }
      if (results) {
        results.innerHTML = partners.map(function (partner) {
          return partnerCard(partner, 'coverage', { compact: true, currentSlug: currentSlug });
        }).join('') + (productIntent
          ? '<button type="button" class="florame-partner-compare-create" data-partner-compare-create>' +
              iconSvg('arrow') + '<span>' + escapeHtml(t('compareCreateSimilar')) + '</span></button>'
          : '');
        var createButton = results.querySelector('[data-partner-compare-create]');
        if (createButton) createButton.addEventListener('click', function () {
          var bouquetData = String(info.bouquetData || '');
          if (bouquetData && typeof window.homeEditBouquet === 'function') {
            if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
            window.setTimeout(function () { window.homeEditBouquet(bouquetData); }, 220);
            return;
          }
          var destination = window.FloramePartner && typeof window.FloramePartner.appUrl === 'function'
            ? window.FloramePartner.appUrl('custom')
            : '/pages/florame-app?mode=custom';
          window.location.assign(destination);
        });
        results.querySelectorAll('a[data-partner-slug]').forEach(function (link) {
          var productId = String(info.productId || '').trim();
          if (productId && /^\/products\//i.test(window.location.pathname || '')) {
            try {
              var productUrl = new URL(window.location.href);
              productUrl.searchParams.set('partner', String(link.getAttribute('data-partner-slug') || ''));
              link.href = productUrl.pathname + productUrl.search + productUrl.hash;
            } catch (_) {}
          }
          link.addEventListener('click', function (event) {
            var nextSlug = String(link.getAttribute('data-partner-slug') || '');
            if (!nextSlug || nextSlug === currentSlug) {
              event.preventDefault();
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
              return;
            }
            if (productIntent && info.bouquetData) {
              event.preventDefault();
              try {
                var bouquet = JSON.parse(decodeURIComponent(String(info.bouquetData || '')));
                localStorage.setItem('florame_temp_edit', JSON.stringify({
                  composition: bouquet.composition || {},
                  packaging: bouquet.packaging || {},
                  fromHome: true,
                  seed: bouquet.seed,
                  promptData: bouquet.promptData
                }));
                var customUrl = new URL('/pages/florame-app', window.location.origin);
                customUrl.searchParams.set('mode', 'custom');
                customUrl.searchParams.set('action', 'edit_temp');
                customUrl.searchParams.set('partner', nextSlug);
                window.dispatchEvent(new CustomEvent('florame:partner-switching', {
                  detail: { currentPartnerSlug: currentSlug, requestedPartnerSlug: nextSlug, reason: 'bouquet_alternative' }
                }));
                window.location.assign(customUrl.pathname + customUrl.search);
                return;
              } catch (_) {}
            }
            window.dispatchEvent(new CustomEvent('florame:partner-switching', {
              detail: { currentPartnerSlug: currentSlug, requestedPartnerSlug: nextSlug, reason: 'customer_compare' }
            }));
          });
        });
      }
    } catch (_) {
      if (status) status.textContent = t('addressError');
      if (results) results.innerHTML = '';
    }
  }

  function wire(root) {
    if (!root || root.__floramePartnerDirectoryReady) return;
    root.__floramePartnerDirectoryReady = true;
    var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
    root.innerHTML = shell(surface);

    var form = root.querySelector('[data-partner-directory-form]');
    var input = root.querySelector('[data-partner-directory-input]');
    var geo = root.querySelector('[data-partner-directory-geo]');
    var expand = root.querySelector('[data-partner-directory-expand]');

    if (expand) {
      expand.addEventListener('click', function () {
        var nextExpanded = root.getAttribute('data-directory-expanded') !== 'true';
        root.setAttribute('data-directory-expanded', nextExpanded ? 'true' : 'false');
        expand.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        expand.textContent = t(nextExpanded ? 'collapse' : 'viewAll');
        if (root.__floramePartnerDirectoryData) renderData(root, root.__floramePartnerDirectoryData);
      });
    }

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var query = input ? input.value : '';
        renderLoading(root, t('searching'));
        var resolved = await resolveAddressQuery(query);
        if (!resolved.cap && !resolved.city && !resolved.address) {
          var status = root.querySelector('[data-partner-directory-status]');
          if (status) status.textContent = t('addressError');
          return;
        }
        await loadDirectory(root, resolved, t('searching'));
      });
    }

    if (geo) {
      geo.addEventListener('click', function () {
        if (!navigator.geolocation) {
          var status = root.querySelector('[data-partner-directory-status]');
          if (status) status.textContent = t('gpsError');
          return;
        }
        renderLoading(root, t('searching'));
        navigator.geolocation.getCurrentPosition(function (position) {
          loadDirectory(root, {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }, t('searching'));
        }, function () {
          var status = root.querySelector('[data-partner-directory-status]');
          var results = root.querySelector('[data-partner-directory-results]');
          if (status) status.textContent = t('gpsError');
          if (results) results.innerHTML = '';
        }, { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 });
      });
    }

    var saved = readSavedCapState();
    if (saved && saved.cap) {
      if (input && saved.address) input.value = saved.address;
      loadDirectory(root, saved, t('loading'));
    } else {
      loadDirectory(root, {}, t('loading'));
    }
  }

  function boot() {
    var roots = Array.from(document.querySelectorAll('[data-florame-partner-directory-root]'));
    if (!roots.length) return;
    if (isPartnerRoute()) {
      roots.forEach(function (root) {
        root.hidden = true;
        var section = root.closest('[data-florame-partner-directory-section]');
        if (section) section.hidden = true;
      });
      return;
    }
    roots.forEach(wire);
  }

  window.addEventListener('florame:native-language-change', function () {
    var roots = Array.from(document.querySelectorAll('[data-florame-partner-directory-root]'));
    if (isPartnerRoute()) {
      roots.forEach(function (root) {
        root.hidden = true;
        var section = root.closest('[data-florame-partner-directory-section]');
        if (section) section.hidden = true;
      });
      return;
    }
    roots.forEach(function (root) {
      root.__floramePartnerDirectoryReady = false;
      wire(root);
    });
  });

  function handleCompareOpen(event) {
    openCompare(event && event.detail || {});
  }
  document.addEventListener('cap-check-finish', function () {
    if (!comparePendingDetail) return;
    var pending = comparePendingDetail;
    comparePendingDetail = null;
    window.setTimeout(function () { openCompare(pending); }, 320);
  });
  window.addEventListener('florame:partner-compare-open', handleCompareOpen);
  document.addEventListener('florame:partner-compare-open', handleCompareOpen);
  window.FloramePartnerDirectory = Object.assign(window.FloramePartnerDirectory || {}, {
    openCompare: openCompare,
    resolveOffers: resolveOffers
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
